import React from 'react';
import './app-header.css';

const AppHeader = ({toDo, done}) => {
  return (
    <div className="app-header d-flex">
      <h1>Список справ</h1>
      <h2>{toDo} в праці, {done} виконано</h2>
    </div>
  );
};

export default AppHeader;
